export default __webpack_public_path__ + "static/media/3027.67b565c4.jpg";